// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"f598e25a","703":"75276aa7"}[chunkId] + ".chunk.js";
};